// extracted by mini-css-extract-plugin
module.exports = {"featured_item":"_1c6ZgRWGGRm4pUad5hBcTn","featured_image":"_1Bj39eCdP-C2bResocDLI3","featured_caption":"oYtDYtASk7C7wL2ukZfYg"};